import { render, staticRenderFns } from "./Pact.vue?vue&type=template&id=44f0ec98&scoped=true&"
import script from "./Pact.vue?vue&type=script&lang=js&"
export * from "./Pact.vue?vue&type=script&lang=js&"
import style0 from "./Pact.vue?vue&type=style&index=0&id=44f0ec98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f0ec98",
  null
  
)

export default component.exports